import React from 'react';
import { ReactComponent as SmallLogo } from 'public-images/logo-small.svg';
import { LogoBlock } from './view';

export const Logo: React.FC = () => {
    return (
        <LogoBlock>
            <SmallLogo />
        </LogoBlock>
    );
};
